import React, { useState, useEffect } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import "../commonSection/commonsection.css";
import RecaptchaComponent from "../commonSection/RecaptchaComponent";
import { submitLeadForm, urlUpdateHandle } from "../../redux/actions/micrositeAction";
import useMicroSiteEncrypt from "../CustomHook/useMicroSiteEncrypt";
import { useDispatch, useSelector } from "react-redux";
import LogoImg from "../../assets/Common/Logo.png"
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import ArrowNew from "../../assets/Common/send.png"
import { Field, Label, Switch } from '@headlessui/react'
import MapComponent from "../commonSection/MapComponent";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { getNewRecaptchaToken } from '../commonSection/RecaptchaComponent';


export default function LeadForm(props) {
    const dispatch = useDispatch();
    const [recaptchaToken, setRecaptchaToken] = useState("");
    const [checkFlag, setCheckFlag] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [mobile, setMobile] = useState("");
    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [message, setMessage] = useState("");
    const { microSiteEncrypt } = useMicroSiteEncrypt();
    const address = useSelector((state) => state.microsite?.home_data?.microsite?.address);
    const home_data = useSelector((state) => state.microsite?.home_data);
    const url_data = useSelector((state) => state.microsite?.url_data);
    const current_flow = useSelector((state) => state.microsite?.home_data?.flow);
    const [recaptchaKey, setRecaptchaKey] = useState(0);
    const customize_fields = useSelector(
        (state) => state.microsite?.home_data?.customization
    );
    
    // Ensure URL is set when component mounts
    useEffect(() => {
        if (!url_data) {
            const currentUrl = window?.location?.href || "";
            dispatch(urlUpdateHandle(currentUrl));
        }
    }, [url_data, dispatch]);
    // Create dynamic gradient style with consistent ratio
     const gradientStyle = {
        background: `linear-gradient(#fff, ${props?.colors?.primary}88)`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        lineHeight: "normal"
    };
    
    const captcha_key =
        window.location.origin.includes("spdevmfp") ||
        window.location.origin.includes("localhost")
            ? "6LfunNgbAAAAAEM0X3hcwSBYKJwIqHmmInfz0uFK"
            : window.location.origin.includes("sppreprod") ||
            window.location.origin.includes("sptestmfp")
            ? "6Ldeg6YaAAAAAAZqU7AQ_j-lG4LcnwP4jfNFiCJJ"
            : "6Lf9fqoaAAAAAH8JhnTg9gLI3KsYKmR2tdCRVg8i";
    
    const refreshRecaptcha = () => {
        setRecaptchaKey(prev => prev + 1);
    };

    const handleCountryChange = (value) => {
        if (value) {
            try {
                const phoneNumberObj = parsePhoneNumber(value);
                const newCountryCode = '+' + phoneNumberObj?.countryCallingCode;
                setCountryCode(newCountryCode);
            } catch (error) {
                console.error('Invalid phone number', error);
            }
        } else {
            setCountryCode('');
        }
    };

    const submitForm = async () => {
        // Validation checks
        if (name == "" && customize_fields?.top_contact?.name?.validation == "required") {
            setNameError(true);
            return;
        } else if ((mobile == "" || mobileError == true) && customize_fields?.top_contact?.phone?.validation == "required") {
            setMobileError(true);
            return;
        } else if ((email == "" && customize_fields?.top_contact?.email?.validation == "required") || emailError == true ) {
            setEmailError(true);
            return;
        } else {
            setNameError(false);
            setMobileError(false);
            setEmailError(false);
        }

        // Get fresh recaptcha token for lead form
        const freshRecaptchaToken = await getNewRecaptchaToken(captcha_key);
        
        // Get current URL - prioritize current window URL over Redux store
        const currentUrl = window?.location?.href || url_data || "";
        
        let payload = {
            fullname: name,
            phoneNo: mobile ? `${countryCode}-${mobile.replace(countryCode, '')}` : "",
            emailId: email,
            message: message,
            recaptcha_token: freshRecaptchaToken,
            url: currentUrl
        }

        const generateToken = async () => {
            const token = await microSiteEncrypt(payload);
            if (token && token !== "") {
                dispatch(
                    submitLeadForm(
                        token,
                        payload,
                        "Let's Discuss",
                        current_flow,
                        onSuccess
                    )
                );
            }
        };

        generateToken();
    };

    const onSuccess = () => {
        setName("");
        setEmail("");
        setMobile("");
        setCountryCode("+91");
        setCheckFlag(false);
        refreshRecaptcha();
    };

    return (
        <div className="lg:max-w-7xl mx-auto">
            <div className="py-2 sm:py-12">
                {!window.location.pathname.includes("category") && <div className="w-3/4 mx-auto max-sm:hidden">
                    {/* <div className="bg-transparent mx-auto w-fit mb-4 p-2"><img src={home_data?.company_logo} alt="logo"/></div> */}
                    <span 
                        className="text-center text-5xl not-italic text-white font-medium"
                        style={{color:"white"}}
                    >
                        {props.ticker}
                    </span> 
                </div>}
                <section id='section6' className={`mx-auto w-[80%] max-sm:w-[95%] ${!window.location.pathname.includes("category") ? "pt-8":""}`}>
                    <div className="flex max-sm:block bg-white max-sm:space-y-8 rounded-3xl max-sm:rounded-lg p-8 max-sm:p-4 gap-8">
                        <div className="w-[50%] max-sm:w-full">
                            <div>
                                <div className="relative">
                                    <input
                                        placeholder={`Your Name ${customize_fields?.top_contact?.name?.validation == "required" ? "*":""}`}                      
                                        id="first-name"
                                        name="first-name"
                                        type="text"
                                        autoComplete="given-name"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 custom_ring_color"
                                        value={name}
                                        onChange={(e) => {  
                                            const regex = /^[a-zA-Z ]*$/;
                                            if (regex.test(e.target.value)) {
                                                setName(e.target.value);
                                            }  
                                            if (e.target.value != "") {
                                                setNameError(false);
                                            }
                                        }}
                                    />
                                    {nameError != false && <ExclamationCircleFill title="Enter a name" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="relative country-customize mt-2.5">
                                    <PhoneInput
                                        flags={flags}
                                        placeholder=""
                                        value={mobile}
                                        defaultCountry="IN"
                                        limitMaxLength
                                        countryCallingCodeEditable={false}
                                        international={true}                            
                                        onChange={(e) => {
                                            if (e) {
                                                setMobile(e);
                                                handleCountryChange(e);
                                                if (isValidPhoneNumber(e)) {
                                                    setMobileError(false); 
                                                } else {
                                                    setMobileError(true); 
                                                }
                                            } else {
                                                setMobile("");
                                                setCountryCode("");
                                                setMobileError(false); 
                                            }
                                        }}
                                    />
                                    {mobileError != false && <ExclamationCircleFill title="Enter a valid mobile number" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                                </div>
                            </div>    
                            <div className="sm:col-span-2">
                                <div className="mt-2.5 relative">
                                    <input
                                        placeholder={`Email ID ${customize_fields?.top_contact?.email?.validation == "required" ? " *":""}`} 
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-6"
                                        value={email}
                                        onChange={(e) => {
                                            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;                       
                                            if (regex.test(e.target.value) || e.target.value == "") {
                                                setEmailError(false);
                                            } else {
                                                setEmailError(true);
                                            }   
                                            setEmail(e.target.value)
                                        }}
                                    />
                                    {emailError != false && <ExclamationCircleFill title="Enter a valid email" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="mt-2.5">
                                <textarea
                                    placeholder="Message"
                                    id="message"
                                    name="message"
                                    className="block w-full h-[160px] max-sm:h-[100px] resize-none rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-6"
                                    value={message}
                                    onChange={(e)=>{setMessage(e.target.value)}}
                                />
                                </div>
                            </div>
                            <div className="sm:col-span-2 mt-2.5 relative flex items-center">
                                {/* <div className="flex h-6 items-center">
                                <input
                                    id="check"
                                    aria-describedby="comments-description"
                                    name="check"
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-[#a7aaaf] text-[#0073BB] focus:ring-[#0073BB]"
                                    value={checkFlag}
                                    onChange={(e)=>{setCheckFlag(e.target.checked)}}
                                />
                                </div> */}
                                <div className="w-full text-left text-sm leading-3">
                                    <span
                                        id="comments-description"
                                        className="text-[#000] text-[9px] not-italic font-normal"
                                    >
                                         I understand that I would be contacted with regards to this request placed and consent for the same in spite of being registered with the National Customer Preference Registry (NCPR) with TRAI. I am aware that there is a de-registration facility (for not receiving such calls) which I may avail if required in future.
                                    </span>
                                </div>
                                <RecaptchaComponent 
                                    key={recaptchaKey} 
                                    onVerify={setRecaptchaToken} 
                                />
                                <button
                                    onClick={submitForm}
                                    type="submit"
                                    style={{
                                        backgroundColor: props?.colors?.secondary,
                                    }}
                                    className="rounded-full items-center flex gap-2 w-28 justify-center py-1.5 text-center text-sm font-semibold text-white shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#E85325]"
                                >
                                        <span className="pt-0.5">Submit</span>
                                        <img src={ArrowNew} alt='arrow'/>
                                </button>
                            </div>
                        </div>
                        <div className="w-[50%] max-sm:w-full">
                            <MapComponent address={address} />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
